<template>
  <div class="loop">
    <h2>
      Boucle {{ id }} <v-chip label class="gradient text-white">{{ challenge_name }}</v-chip>
    </h2>

    <FiltersClassement @onChangeFilters="onChangeFilters" :hide_challenge="false"></FiltersClassement>
    <TableauClassement v-if="loop" :loop="loop" :filters="filters"></TableauClassement>
  </div>
</template>

<script>
import FiltersClassement from "@/components/Classements/FiltersClassements.vue";
import TableauClassement from "@/components/Classements/TableauClassement.vue";
// @ is an alias to /src

export default {
  name: "HomeView",
  components: {
    FiltersClassement,
    TableauClassement,
  },
  data() {
    return {
      id: 1,
      challenge_uuid: "",
      filters: {
        challenge: "Tous",
        sexe: "Tous",
        search: "",
      },
    };
  },
  watch: {
    "$route.params.id": {
      handler: function (id) {
        this.id = id;

        //this.$store.dispatch("fetchLoop", { id: this.id });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    challenge_name() {
      switch (this.challenge_uuid) {
        case "12_boucles":
          return "Challenge 12 boucles";
        case "12_boucles_relai":
          return "Challenge 12 boucles relai";
        default:
          return this.challenge_uuid;
      }
    },
    loop() {
      return this.$store.getters.getChallengeLoopById();
    },
  },
  methods: {
    onChangeFilters(filters) {
      this.filters = filters;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.challenge_uuid = this.$route.params.challenge_uuid;
    //this.$store.dispatch("fetchLoop", { id: this.id });
  },
};
</script>
